import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://pknjekgwmqrolkkubhrx.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBrbmpla2d3bXFyb2xra3ViaHJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzODc3MjYsImV4cCI6MjA2Mzk2MzcyNn0.FDMBdeZtrvvUKwu-FfnljKYfHj4yrDBUVJ_OrWR87_k';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types for TypeScript
export interface User {
  id: string;
  email: string;
  name: string;
  subscription: 'free' | 'premium';
  weekly_time_allocation: number;
  age?: number | null;
  annual_income?: number | null;
  created_at: string;
  updated_at: string;
}

export interface Goal {
  id: string;
  user_id: string;
  title: string;
  description: string;
  category: 'longevity' | 'healthspan' | 'wellness';
  priority: 'low' | 'medium' | 'high';
  progress: number;
  target_date: string;
  time_required: number;
  status: 'active' | 'completed' | 'paused';
  created_at: string;
  updated_at: string;
}

export interface TalentTree {
  id: string;
  user_id: string;
  tree_id: string;
  name: string;
  description: string;
  nodes: any[];
  total_time_allocated: number;
  created_at: string;
  updated_at: string;
}

export interface TalentNode {
  id: string;
  tree_id: string;
  node_id: string;
  name: string;
  description: string;
  category: string;
  level: number;
  max_level: number;
  time_required: number;
  prerequisites: string[];
  unlocked: boolean;
  progress: number;
  benefits: string[];
  created_at: string;
  updated_at: string;
}

// Edge Function Response Types
export interface Achievement {
  id: string;
  name: string;
  description: string;
  category: string;
  unlocked_at: string;
}

export interface LevelUpInfo {
  leveledUp: boolean;
  newLevel: number;
  previousLevel: number;
}

export interface GoalCompletionRewards {
  xpGained: number;
  streakBonus: number;
  newAchievements: Achievement[];
  levelUp: LevelUpInfo;
}

export interface GoalCompletionResponse {
  success: boolean;
  message: string;
  rewards: GoalCompletionRewards;
  updatedGoal: Goal;
}

export interface HealthWorthAssessment {
  id: string;
  user_id: string;
  
  // Cardiovascular metrics
  resting_heart_rate: number | null;
  morning_hrv: number | null;
  vo2_max: number | null;
  
  // Metabolic metrics
  fasting_glucose: number | null;
  hba1c: number | null;
  ldl_hdl_ratio: number | null;
  
  // Body composition
  body_fat_percentage: number | null;
  body_fat_dexa: boolean;
  waist_to_height_ratio: number | null;
  
  // Strength metrics
  squat_weight: number | null;
  deadlift_weight: number | null;
  pull_ups: number | null;
  grip_strength: number | null;
  body_weight: number | null;
  
  // Lifestyle factors
  sleep_quality: string;
  stress_level: string;
  energy_level: string;
  overall_wellbeing: string;
  
  // Financial data
  annual_income_pre_tax: number | null;
  age: number | null;
  
  // Calculated values
  future_earning_capacity: number;
  
  // Assessment metadata
  assessment_date: string;
  notes?: string;
  
  // Timestamps
  created_at: string;
  updated_at: string;
} 